import React, { useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import BackgroundImage from '../../components/BackgroundImage';
import Header from '../../components/Header';
import Spinner from '../../components/Spinner';
import useFetch from '../../hooks/useFetch';
import { StaticContentContext } from '../../Layout';

import "./style.scss";

function Publication() {
  const {id} = useParams();
  const {staticContent: {publication}, notFoundEndpoint} = useContext(StaticContentContext);
  const [publications, loading] = useFetch("/publication?acf_format=standard&slug=" + id, []);
  const content = publications[0]?.acf;

  if (!loading && !content) {
    return <Navigate to={notFoundEndpoint} />;
  }
  
  return loading ? (
    <div className="Design">
      <Spinner size="xlarge" centered />
    </div>
  ) : (
    <>
      <Header content={publications[0]} />
      <BackgroundImage className="Publication" content={publication}>
        <div className="Publication__header" style={{color: publication?.text_color}}>
          <img className="Publication__image" src={content.image.sizes.large} alt={content.image.alt} />
          <div>
            <PublicationItem label="Forfatter">{content.author}</PublicationItem>
            <PublicationItem label="Udgivelsesår">{content.publicationyear}</PublicationItem>
          </div>
        </div>
        <div className="Publication__content">
          <PublicationItem label="Beskrivelse">
            <div dangerouslySetInnerHTML={{__html: content.descriptive_text}} />
          </PublicationItem>
        </div>
      </BackgroundImage>
    </>
  );
}

function PublicationItem({label, children}) {
  if (!children) return null;
  return (
    <div className="PublicationItem">
      <p className="PublicationItem__label">{label}</p>
      {children}
    </div>
  );
}

export default Publication;
